/**
 * Site footer with product and legal links.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { openCookieBanner } from '../utils/cookieConsent';
import './Footer.css';

const Footer = () => {
  const { isAuthenticated } = useAuth();
  const { t, localePath } = useLanguage();

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <Link to={localePath('/')} className="site-footer__logo">
            ClarCV
          </Link>
          <span className="site-footer__dot" aria-hidden="true">
            ·
          </span>
          <span>{t('footer.tagline')}</span>
        </div>
        <nav className="site-footer__links" aria-label={t('footer.navLabel')}>
          <Link to={localePath('/')}>{t('footer.home')}</Link>
          <Link to={localePath('/pricing')} className="is-accent">
            {t('footer.pricing')}
          </Link>
          <Link to={localePath('/blog')}>{t('footer.blog')}</Link>
          <Link to={localePath('/privacy')}>{t('footer.privacy')}</Link>
          <Link to={localePath('/terms')}>{t('footer.terms')}</Link>
          <button type="button" className="site-footer__cookies" onClick={openCookieBanner}>
            {t('footer.cookies')}
          </button>
          {!isAuthenticated && <Link to="/login">{t('footer.login')}</Link>}
          <span aria-hidden="true">© {new Date().getFullYear()} ClarCV</span>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
